import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showError, showSuccess } from "utils/notifications";
import { loginUser } from "adminApi/AuthenticationApi/Login";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const credentials = [
    { email: "admin@example.com", password: "SecurePassword123!" },
    { email: "admin@gmail.com", password: "Admin@12345" },
  ];

  // ─── handleLogin (inside your Login component) ───────────────────────────────
  // ─── handleLogin (inside your Login component) ────────────────────────────────
  // Backend response shape is always:
  // { success, message, data: { accessToken, refreshToken, csrfToken, user } }
  // No need for flat fallbacks.

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await loginUser(email, password);

      // loginUser should return res.data from the axios call
      // so res = { success, message, data: { accessToken, refreshToken, csrfToken, user } }
      if (!res.success) {
        throw new Error(res.message || "Login failed");
      }

      const { accessToken, refreshToken, csrfToken, user } = res.data;

      if (!accessToken || !csrfToken || !refreshToken) {
        throw new Error("Incomplete token data received from server.");
      }

      // Persist all three — all three are required for refresh + logout
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("csrfToken", csrfToken);
      if (user) localStorage.setItem("user", JSON.stringify(user));

      dispatch({ type: "SET_TOKEN", payload: accessToken });

      showSuccess(res.message || "Login successful");
      navigate("/admin/index", { replace: true });

    } catch (err) {
      console.error("Login error:", err);
      showError(
        err.response?.data?.message ||
        err.message ||
        "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFillCredentials = (credEmail, credPassword) => {
    setEmail(credEmail);
    setPassword(credPassword);
  };

  return (
    <div className="px-xl-5 px-2 auth-body">
      <form onSubmit={handleLogin}>
        <ul className="row g-3 list-unstyled li_animate">
          <li className="col-12">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              className="form-control form-control-lg"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </li>
          <li className="col-12">
            <div className="form-label">
              <span className="d-flex justify-content-between align-items-center">
                Password
                {/* <Link className="text-primary" to="/password-reset">
                  Forgot Password?
                </Link> */}
              </span>
            </div>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                className="form-control form-control-lg pe-5"
                placeholder="Enter password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <i className="bi bi-eye"></i>
                ) : (
                  <i className="bi bi-eye-slash"></i>
                )}
              </button>
            </div>
          </li>
          <li className="col-12">
            <div className="form-check fs-5">
              <input
                className="form-check-input"
                type="checkbox"
                id="Rememberme"
              />
              <label className="form-check-label fs-6" htmlFor="Rememberme">
                Remember this Device
              </label>
            </div>
          </li>
          <li className="col-12 mt-lg-4">
            <button
              type="submit"
              className="btn btn-lg w-100 btn-primary text-uppercase mb-2"
              title="sign in"
              disabled={loading}
            >
              {loading ? <>loading... <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span></> : "SIGN IN"}
            </button>
          </li>
          <li className="col-12">
            <div className="mt-2">
              <p className="text-muted small mb-2 d-flex align-items-center gap-1">
                <span className="badge bg-secondary-subtle text-secondary rounded-pill px-2">Demo</span>
                Click any row to auto-fill credentials
              </p>
              <div className="list-group list-group-flush rounded-3 border overflow-hidden">
                {credentials.map((cred, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => handleFillCredentials(cred.email, cred.password)}
                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center px-3 py-2"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span className="avatar sm rounded-circle bg-primary-subtle text-primary fw-semibold" style={{ width: 30, height: 30, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>
                        {cred.email.charAt(0).toUpperCase()}
                      </span>
                      <span className="text-body small fw-medium">{cred.email}</span>
                    </div>
                    <span className="badge bg-light text-muted border font-monospace small">{cred.password}</span>
                  </button>
                ))}
              </div>
            </div>
          </li>
          {/* <li className="col-12 text-center">
            <span className="text-muted d-flex justify-content-center">
              New to Renbow Resort{" "}
              <Link className="ms-2" to="/signup" title="Sign up">
                Sign up here
              </Link>
            </span>
          </li> */}
        </ul>
      </form>
    </div>
  );
};

export default Signin;
